<template>
  <div class="app-container">
    <!-- 查询条件 -->
    <div ref="searchBox" class="formBox margbot">
      <el-form :inline="true" :model="formData" class="demo-form-inline" size="mini" label-width="100px">
        <div class="formItemBox">
        <el-form-item label="转货单号:">
          <el-input v-model="formData.changeNo" placeholder="请输入转货单号" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="转货日期:">
          <div style="display: flex;">
            <el-date-picker v-model="formData.dateStart" size="mini" type="date" placeholder="请选择转货日期"
              value-format="yyyy-MM-dd 00:00:00"></el-date-picker>
            -
            <el-date-picker v-model="formData.dateEnd" size="mini" type="date" placeholder="请选择转货日期"
              value-format="yyyy-MM-dd 23:59:59"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="原一级货主:">
          <el-select v-model="formData.oldPrimaryCustomerTaxId" size="mini" filterable placeholder="请选择原一级货主"
            clearable>
            <el-option v-for="(item, index) in OwnerData" :key="index" :label="item.custerName"
              :value="item.taxpayerNumber"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="原二级货主:">
          <el-select v-model="formData.oldCustomerTaxId" size="mini" filterable placeholder="请选择原二级货主" clearable>
            <el-option v-for="(item, index) in OwnerData" :key="index" :label="item.custerName"
              :value="item.taxpayerNumber"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="货权方:">
          <el-select v-model="formData.ownerCustomerTaxId" filterable size="mini" placeholder="请选择货权方" clearable>
            <el-option v-for="(item, index) in HQData" :key="index" :label="item.custerName"
              :value="item.taxpayerNumber">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="现一级货主:">
          <el-select v-model="formData.newPrimaryCustomerTaxId" size="mini" filterable placeholder="请选择现一级货主"
            clearable>
            <el-option v-for="(item, index) in OwnerData" :key="index" :label="item.custerName"
              :value="item.taxpayerNumber"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="现二级货主:">
          <el-select filterable v-model="formData.newCustomerTaxId" size="mini" placeholder="请选择现二级货主" clearable>
            <el-option v-for="(item, index) in OwnerData" :key="index" :label="item.custerName"
              :value="item.taxpayerNumber"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据来源:">
          <el-select v-model="formData.source" size="mini" placeholder="请选择数据来源" clearable>
            <el-option v-for="(item, index) in SjData" :key="index" :label="item.show_name"
              :value="item.item_no"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="转货提单号:">
          <el-input v-model="formData.changeBillNo" placeholder="请输入转货提单号" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="转货外部单号:">
          <el-input v-model="formData.transferExternalNo" placeholder="请输入转货外部单号" size="mini"></el-input>
        </el-form-item>
        </div>
        <el-form-item style="margin-left: 5px;">
          <el-button type="primary" size="mini" @click="chaxun" btnCode="003P01FB001"
            v-if="btnFlg[0]">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi" btnCode="003P01FB002"
            v-if="btnFlg[1]">重置</el-button>
          <el-button type="primary" size="mini" @click="shenhe" btnCode="003P01FB003"
            v-if="btnFlg[2]">审核</el-button>
            <!-- 20240130 念头西库 -->
          <el-button type="primary" size="mini" @click="shenhe1" btnCode="003M2X0100"
            v-if="btnFlg[7]">审核</el-button>
          <el-button type="primary" size="mini" @click="shanchu" btnCode="003P01FB004"
            v-if="btnFlg[3]">删除</el-button>
          <el-button type="primary" size="mini" @click="eidtWBDHfn" btnCode="003P01FB004"
            >修改外部单号</el-button>
        </el-form-item>

      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{ height: h }">
      <el-table height="100%" size="mini" ref="tabref1" highlight-current-row :data="tableData" style="width: 100%"
        class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" @row-click="dianjixuanzhong"
        border center bordersize="mini">
        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="danju" label="操作" align="center" width="200">
          <template v-slot="scope">
            <el-button type="text" size="small" @click="lookImg(scope.row)">查看单据
            </el-button>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="changeNo" label="转货单号" align="center"
          width="250"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="oldPrimaryCustomerName" label="原一级货主" align="center"
          width="250"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="oldSecondaryCustomerName" label="原二级货主" align="center"
          width="250"></el-table-column>
        <el-table-column prop="oldOwnerCustomerName" label="货权方" width="250"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="newPrimaryCustomerName" label="现一级货主" align="center"
          width="250"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="newSecondaryCustomerName" label="现二级货主" align="center"
          width="250"></el-table-column>
        <el-table-column prop="changeBillNo" :show-overflow-tooltip="true" label="转货提单号" align="center"
          width="210"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="sourceName" label="数据来源" align="center"
          width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="applicantName" label="申请人" align="center"
          width="200"></el-table-column>
        <el-table-column prop="applicantDate" :show-overflow-tooltip="true" label="转货时间" align="center"
          :formatter="dateTimeFormat" width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="transferExternalNo" label="转货外部单号" align="center"
          width="200"></el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div class="pags" style="text-align: right;">
      <el-pagination background @current-change="handleCurrentChangeA" :current-page="formData.pageNo"
        :page-size="formData.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeA"
        :total="total"></el-pagination>
    </div>
    <!-- 货物明细 -->
    <div class="market_out">
      <div class="detailsTitle">
        <h4>货物明细</h4>
      </div>
      <div>
        <div ref="searchBox2">

          <!-- <el-button
        type="primary"
        size="mini"
        @click="xiugaiJz"
        >修改净重</el-button> -->
        </div>
        <div style="margin-top:5px;margin-bottom:5px;margin-left:10px;">
          <el-button type="primary" size="mini" @click="shanchudown" btnCode="003P01FB005"
            v-if="btnFlg[4]">删除</el-button>
          <el-button type="primary" size="mini" @click="addJz" btnCode="003P01FB006"
            v-if="btnFlg[5]">添加净重</el-button>
          <span>总重量:
            <span style="color:red">{{ allWeight }}</span> 吨
          </span>
          <span>总件数:
            <span style="color:red">{{ allNumber }}</span> 件
          </span>
        </div>
        <!-- 详情表 -->
        <div>
          <div :style="{ height: detailsH }">
            <el-table height="100%" size="mini" :data="detailsData" style="width:100%" ref="table2"
              :header-cell-style="{ background: '#F5F5F5', color: 'black', }" border center bordersize="mini"
              highlight-current-row @row-click="dianjixuanzhongXQ" class="tableComent">
              <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
              <el-table-column prop="chargMethod" label="收费方式" align="center" width="150"></el-table-column>
              <el-table-column prop="productTypeName" label="货物类型" align="center" width="150"></el-table-column>
              <el-table-column prop="steelMillName" label="产地" align="center" min-width="250"></el-table-column>
              <el-table-column prop="specification" label="规格" align="center" width="150"></el-table-column>
              <el-table-column prop="model" label="材质" align="center" width="150"></el-table-column>
              <el-table-column prop="number" label="件数" align="center" width="150"></el-table-column>
              <el-table-column prop="allWeight" label="申请重量(吨)" align="center" width="150">
                <template slot-scope="scope">
                  <div>
                    <span v-if="scope.row.allWeight == undefined || scope.row.allWeight == ''"></span>
                    <span v-else>{{ Number(scope.row.allWeight).toFixed(3) }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="weight" label="理重(吨)" align="center" width="150">
                <template slot-scope="scope">
                  <div>
                    <span v-if="scope.row.weight == undefined || scope.row.weight == ''"></span>
                    <span v-else>{{ Number(scope.row.weight).toFixed(3) }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="weighingWeight" label="过磅净重(吨)" align="center" width="150">
                <template slot-scope="scope">
                  <div>
                    <span v-if="scope.row.weighingWeight == undefined || scope.row.weighingWeight == ''"></span>
                    <span v-else>{{ Number(scope.row.weighingWeight).toFixed(3) }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="weighingDate" label="净重过磅时间" align="center" min-width="200"
                :formatter="dateTimeFormat">
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页-->
          <div class="pags" style="text-align: right;">
            <el-pagination background @current-change="handleCurrentChangeXQ" :current-page="pageNoXQ"
              :page-size="pageSizeXQ" :page-sizes="[10, 20, 30, 40, 50]"
              layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeXQ"
              :total="totalXQ"></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 审核 -->
    <div class="shenhe">
      <el-dialog title="审核" :visible.sync="shVisible" :close-on-click-modal="false" width="30%" center="" @close='closeSH'>
        <el-form :model="shFormData" ref="shFormData" label-width="100px" class="demo-dynamic"
          style="margin: 30px auto" :rules="shRules">
          <el-form-item prop="changeStatus" label="审核结果" :rules="[
            {
              required: true,
              message: '请选择审核结果',
              trigger: 'change'
            }
          ]">
            <el-radio-group v-model="shFormData.changeStatus" @change="RadioChange">
              <el-radio label="1">同意</el-radio>
              <el-radio label="2">驳回</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="审核意见">
            <el-input type="textarea" :rows="4" maxlength="50" placeholder="请输入审核意见"
              v-model="shFormData.approverReject">
            </el-input>
          </el-form-item>
        </el-form>
        <div style="width: 145px; margin: 15px auto">
          <el-button @click="closeSH">取 消</el-button>
          <el-button type="primary" @click="succeshenhe" :loading='shenheLoading'>保 存</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 添加净重 -->
    <div class="addjingzhong">
      <el-dialog title="添加净重" :visible.sync="addJingzhongVisible" :close-on-click-modal="false" width="50%" center>
        <el-form :model="addFormData" ref="addFormData" label-width="200px" class="demo-dynamic"
          style="width: 400px; margin: 30px auto">
          <el-form-item prop="weighingWeight" label="过磅净重（吨）" :rules="[
            {
              required: true,
              message: '请输入过磅净重',
              trigger: 'blur',
            },
          ]">
            <el-input v-model="addFormData.weighingWeight" size="mini" placeholder="请输入过磅净重"
              v-number-input.float="3" style="width: 200px" type="number"></el-input>
          </el-form-item>
          <el-form-item prop="weighingDate" label="实际过磅时间" :rules="[
            {
              required: true,
              message: '请选择实际过磅时间',
              trigger: 'change',
            },
          ]">
            <el-date-picker v-model="addFormData.weighingDate" size="mini" type="datetime" placeholder="选择过磅日期"
              value-format="yyyy-MM-dd HH:mm:ss" style="width: 200px"></el-date-picker>
          </el-form-item>
        </el-form>
        <div style="width: 180px; margin: 15px auto">
          <el-button @click="closeaddJz">取 消</el-button>
          <el-button type="primary" @click="addJzDialog" :loading='addJzLoading'>保 存</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 查看单据 -->
    <div class="addMarkBox">
      <el-dialog title="查看凭证" :close-on-click-modal="false" :visible.sync="addMarkLookBox" width="80%" center>
        <div class="img_box" v-if="!imgFlag">
          <div>暂未上传凭证</div>
        </div>
        <div class="box1" v-else>
          <div class="leftbox img_box">
            <div v-for="(item, index) in imgData" :key="index" @click="handChange(item.url, item.urlPrimary)"
              class="imgbox">
              <div v-if="item.urlPrimary.substring(item.urlPrimary.length - 3) === 'pdf'">
                <img src="@/assets/images/pdf.jpg">
                <!-- <i v-if="seen" class="el-icon-delete" @click="delImg(item)" btnCode=""></i> -->
              </div>
              <div v-else>
                <img :src="item.url" alt />
                <!-- <i v-if="seen" class="el-icon-delete" @click="delImg(item)" btnCode=""></i> -->
              </div>
            </div>
          </div>
          <div class="rightbox">
            <div v-if="pdfFlag" class="pdfbox">
              <iframe :src="path" frameborder="0" style="width: 100%; height:100%"></iframe>
            </div>
            <div class="imgDialog" v-else>
              <img :src="path" alt />
            </div>
          </div>
        </div>
        <div style="width:80px;margin:15px auto;">
          <el-button type="primary" @click="lookQuXiao">取消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 查看单据照片 -->
    <!-- <div>
      <el-dialog
        title="查看单据照片"
        center
        :visible.sync="dialogVisibleImg"
        width="35%"
      >
        <div
          class="demo-image__preview"
          v-if="!lookFlag"
          style="display: flex"
        >
          <el-image
            :preview-src-list="getSrcList()"
            fit="cover"
            v-for="(item, index) in imgList2"
            :key="index"
            style="
              width: 100px;
              height: 100px;
              display: block;
              margin-left: 5px;
            "
            :src="item"
          >
          </el-image>
        </div>
        <span v-if="lookFlag">暂无图片</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisibleImg = false"
            >确 定</el-button
          >
          <el-button @click="dialogVisibleImg = false">关 闭</el-button>
        </span>
      </el-dialog>
      </div> -->
    <!-- 修改外部单号 -->
  <el-dialog title="修改外部单号" :visible.sync="dialogWBDH" :close-on-click-modal="false" @close="dialogWBDH = false"
    width="40%" center>
    <!--form表单-->
    <el-form :model="wbdhForm" ref="wbdhForm" label-width="120px" class="demo-dynamic"
      style="width:350px;margin:30px auto;">
      <el-form-item prop="transferExternalNo" label="转货外部单号" :rules="[
          {
            required: true,
            message: '请输入转货外部单号',
            trigger: 'blur',
          }
        ]">
        <el-input v-model="wbdhForm.transferExternalNo" size="mini" style="width: 200px"
            type="text" :maxlength="20"></el-input>
      </el-form-item>
    </el-form>
    <div style="width:160px;margin:15px auto;">
      <el-button @click="dialogWBDH = false">取 消</el-button>
      <el-button type="primary" @click="wbdhSaveFn()" :loading="addLoad">确 定</el-button>
    </div>
  </el-dialog>
      <!-- 20240129 审核 -->
  <ZHshenhe v-if="ZHshenheVisible" :zhuData="xuanzhongArr" :ZHshenheVisible.sync='ZHshenheVisible'></ZHshenhe>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import {
  getTEmptyChangeMasterList,
  getTEmptyChangeDetailList,
  changeExamineExp,
  getRelationCustomer,
  deleteTEmptyChangeMaster,
  delTEmptyChangeDetail,
  updateTEmptyChangeDetail,
  zidian,
  getImgShow,
  getSBillFileUrl,
  updateTransferExternalNo,
  updateImage

} from '@/api/wms-stock'
import DonMessage from '@/utils/message'
import {
  dateTimeFormat
} from '@/utils/util'
import ZHshenhe from './ZHshenhe.vue'
export default {
  components: {
    ZHshenhe
  },
  data () {
    return {
      path: '',
      imgFlag: true,
      imgData: [],
      pdfFlag: false,
      addMarkLookBox: false,
      dateTimeFormat: dateTimeFormat, // 列表时间格式化

      formData: {
        changeNo: '',
        dateStart: '',
        dateEnd: '',
        oldPrimaryCustomerTaxId: '',
        oldCustomerTaxId: '',
        newPrimaryCustomerTaxId: '',
        newCustomerTaxId: '',
        productType: '',
        source: '',
        changeBillNo: '',
        pageNo: 1,
        pageSize: 20,
        ownerCustomerTaxId: ''
      },
      total: 0,
      SjData: [],
      btnFlg: [],
      btnArr: [
        '003P01FB001',
        '003P01FB002',
        '003P01FB003',
        '003P01FB004',
        '003P01FB005',
        '003P01FB006',
        '003P01FB007',
        '003M2X0100'
      ],
      h: '200px',
      tableData: [],
      activeName: 'first',
      allWeight: '0',
      allNumber: '0',
      detailsH: '200px',
      detailsData: [],
      shFormData: {
        changeStatus: '',
        approverReject: ''
      },
      shVisible: false,
      radio: 2,
      addJingzhongVisible: false,
      addFormData: {
        weighingWeight: '',
        weighingDate: ''
      },
      xuanzhongArr: null,
      pageSizeXQ: 20,
      pageNoXQ: 1,
      totalXQ: 0,

      OwnerData: [],
      HQData: [], // 货权方
      huowuData: [],
      xuanzhongArrXQ: null,
      shenheLoading: false,
      addJzLoading: false,
      dialogVisibleImg: false,
      imgList2: [],
      lookFlag: false,
      shRules: {
        changeStatus: [{ required: true, message: '请选择审核结果', trigger: 'change' }],
        approverReject: [{ required: false, message: '请选择审核结果', trigger: 'change' }]
      },
      ZHshenheVisible: false,
      dialogWBDH: false,
      wbdhForm: {},
      addLoad: false
    }
  },
  methods: {
    // 修改外部单号
    eidtWBDHfn () {
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      this.wbdhForm = {}
      this.wbdhForm.changeId = this.xuanzhongArr.changeId
      this.$set(this.wbdhForm, 'transferExternalNo', this.xuanzhongArr.transferExternalNo)
      this.dialogWBDH = true
    },
    wbdhSaveFn () {
      this.addLoad = true
      this.$refs.wbdhForm.validate((valid) => {
        if (valid) {
          updateTransferExternalNo(this.wbdhForm).then((res) => {
            this.dialogWBDH = false
            this.$message.success('修改成功')
            this.getTEmptyChangeMasterLists()
            this.addLoad = false
          }).catch((err) => {
            this.$message.error(err.message)
            this.addLoad = false
          })
        } else {
          this.addLoad = false
        }
      })
    },
    // 查看凭证-取消
    lookQuXiao () {
      this.addMarkLookBox = false
    },
    // 查看凭证-放大
    handChange (url, urlPrimary) {
      console.log(url, 2)
      this.path = url
      let str = urlPrimary.substring(urlPrimary.length - 3)
      if (str === 'pdf') {
        this.pdfFlag = true
      } else {
        this.pdfFlag = false
      }
      console.log(str)
      // this.dialogVisible = true
    },
    RadioChange (val) {
      console.log(val)
      if (val == 2) {
        this.$set(this.shRules.approverReject[0], 'required', true)
      } else {
        this.$set(this.shRules.approverReject[0], 'required', false)
      }
    },
    chaxun () {
      this.getTEmptyChangeMasterLists()
    },
    chongzhi () {
      this.formData.changeNo = ''
      this.formData.dateStart = ''
      this.formData.dateEnd = ''
      this.formData.oldPrimaryCustomerTaxId = ''
      this.formData.oldCustomerTaxId = ''
      this.formData.newPrimaryCustomerTaxId = ''
      this.formData.newCustomerTaxId = ''
      this.formData.productType = ''
      this.formData.source = ''
      this.formData.changeBillNo = ''
      this.formData.ownerCustomerTaxId = ''
      this.getTEmptyChangeMasterLists()
    },
    shenhe () {
      if (this.tableData.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        })
        return
      }
      this.shVisible = true
    },
    shenhe1 () {
      if (this.tableData.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        })
        return
      }
      this.ZHshenheVisible = true
    },
    shanchu () {
      if (this.tableData.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        })
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      getTEmptyChangeDetailList(
        {
          changeId: this.xuanzhongArr.changeId,
          pageNo: this.pageNoXQ,
          pageSize: this.pageSizeXQ
        }
      )
        .then(res => {
          console.log(res)
          // this.detailsData = res.pageInfo.list
          // this.xuanzhongArrXQ = res.pageInfo.list[0]
          if (res.pageInfo.list.length == 0) {
            const that = this
            this.$confirm('删除后数据不可恢复，确定删除吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              deleteTEmptyChangeMaster(
                {
                  changeId: this.xuanzhongArr.changeId
                }
              )
                .then(res => {
                  DonMessage.success('删除成功')
                  that.getTEmptyChangeMasterLists()
                })
                .catch(error => {
                  DonMessage.error(error.message)
                  console.log(error)
                })
            })
          } else {
            DonMessage.error('本单下有货物，不可删除')
          }
        })
        .catch(err => {
          this.$message({
            message: err,
            type: 'error'
          })
        })
    },
    shanchudown () {
      if (this.detailsData.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        })
        return
      }
      if (this.xuanzhongArrXQ == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      const that = this
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delTEmptyChangeDetail(
          {
            changeDetailId: this.xuanzhongArrXQ.changeDetailId
          }
        )
          .then(res => {
            DonMessage.success('删除成功')
            that.getTEmptyChangeDetailListS()
          })
          .catch(error => {
            DonMessage.error(error.message)
            console.log(error)
          })
      })
    },
    addJz () {
      if (this.detailsData.length == 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        })
        return
      }
      this.addJingzhongVisible = true
      this.addJzLoading = false
    },
    succeshenhe () {
      this.$refs.shFormData.validate((valid) => {
        if (valid) {
          this.shenheLoading = true
          changeExamineExp(
            {
              changeId: this.xuanzhongArr.changeId,
              ...this.shFormData
            }
          )
            .then(res => {
              console.log(res)
              this.shenheLoading = false
              this.shVisible = false
              DonMessage.success('审核成功')

              this.getTEmptyChangeMasterLists()
            })
            .catch(err => {
              this.shenheLoading = false
              this.$message(
                {
                  message: err.message,
                  type: 'error'
                }
              )
            })
        } else {
          this.shenheLoading = false

          console.log('error submit!!')
          return false
        }
      })
    },
    closeSH () {
      this.shVisible = false
      this.$refs.shFormData.resetFields()
    },
    addJzDialog () {
      this.$refs.addFormData.validate((valid) => {
        if (valid) {
          if (this.addFormData.weighingWeight > this.xuanzhongArrXQ.allWeight) {
            this.$message({
              message: '填写的净重必须小于等于转货申请吨数',
              type: 'error'
            })
            return
          }
          this.addJzLoading = true
          updateTEmptyChangeDetail(
            {
              changeId: this.xuanzhongArr.changeId,
              changeDetailId: this.xuanzhongArrXQ.changeDetailId,
              ...this.addFormData
            }
          )
            .then(res => {
              this.addJingzhongVisible = false
              this.getTEmptyChangeDetailListS()

              console.log(res)
            })
            .catch(err => {
              this.addJzLoading = false

              this.$message({
                message: err.message,
                type: 'error'
              })
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeaddJz () {
      this.addJingzhongVisible = false
      this.$refs.addFormData.resetFields()
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      console.log(row)
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
      this.getTEmptyChangeDetailListS()
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          this.OwnerData = res
          this.HQData = JSON.parse(JSON.stringify(res))
          this.HQData.unshift({ 'custerName': '无货权方', 'taxpayerNumber': '-1' })
        })
        .catch((err) => {
          // .error(err.message)
          console.log(err)
        })
      zidian({
        groupNo: 'thread_product_type'
      })
        .then((res) => {
          this.huowuData = res
        })
        .catch((err) => {
          console.log(err)
        })
      zidian({
        groupNo: 'source'
      })
        .then((res) => {
          // console.log(res)
          this.SjData = res
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 分页
    handleCurrentChangeA (val) {
      this.formData.pageNo = val
      this.getTEmptyChangeMasterLists()
    },
    handleSizeChangeA (val) {
      this.formData.pageSize = val
      this.getTEmptyChangeMasterLists()
    },
    handleCurrentChangeXQ (val) {
      this.pageNoXQ = val
      this.getTEmptyChangeDetailListS()
    },
    handleSizeChangeXQ (val) {
      this.pageSizeXQ = val
      this.getTEmptyChangeDetailListS()
    },
    getTEmptyChangeMasterLists () {
      getTEmptyChangeMasterList(
        { ...this.formData }
      )
        .then(res => {
          console.log(res)
          this.total = res.total
          this.tableData = res.list
          if (res.list.length > 0) {
            this.xuanzhongArr = res.list[0]
            this.$nextTick(() => { this.$refs.tabref1.setCurrentRow(res.list[0]) })
            this.getTEmptyChangeDetailListS()
          } else {
            this.detailsData = []
            this.allWeight = 0
            this.allNumber = 0
            this.totalXQ = 0
          }
        })
        .catch(err => {
          this.$message({
            message: err,
            type: 'error'
          })
        })
    },
    getTEmptyChangeDetailListS () {
      getTEmptyChangeDetailList(
        {
          changeId: this.xuanzhongArr.changeId,
          pageNo: this.pageNoXQ,
          pageSize: this.pageSizeXQ
        }
      )
        .then(res => {
          console.log(res)
          // this.detailsData = res.pageInfo.list
          // this.xuanzhongArrXQ = res.pageInfo.list[0]
          this.detailsData = res.pageInfo.list
          if (res.pageInfo.list.length > 0) {
            this.xuanzhongArrXQ = res.pageInfo.list[0]
            this.$nextTick(() => {
              this.$refs.table2.setCurrentRow(res.pageInfo.list[0])
            })
          } else {
            this.detailsData = []
          }
          this.totalXQ = res.pageInfo.total
          this.allNumber = res.all.allNumber
          this.allWeight = res.all.allWeight
        })
        .catch(err => {
          this.$message({
            message: err,
            type: 'error'
          })
        })
    },
    // 删除凭证
    // delImg (item) {
    //   this.$confirm('确定删除图片?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   })
    //     .then(() => {
    //       updateImage({
    //         imgId: item.imgId // 变更图片表id
    //       })
    //         .then(res => {
    //           DonMessage.success('操作成功!')
    //           this.getImgShowB()
    //         })
    //         .catch(err => {
    //           DonMessage.error(err.message)
    //         })
    //     })
    //     .catch(() => {})
    // },
    // 查看图片
    lookImg (row) {
      getImgShow({
        businessId: row.changeId, // ( 业务id <取列表的巡检id sceneInspectionId> 必填)
        businessType: 'empty_change' // （业务类型 必填） 传固定值 'scene_inspection_type'
      })
        .then((res) => {
          console.log(res)
          this.imgData = []
          this.imgFlag = true
          if (res.length < 1) {
            this.imgFlag = false
            return
          }
          this.imgData = res
          // this.pdfFlag = false
          this.seen3 = false
          this.seen2 = true

          this.imgList2 = []
          if (this.xuanzhongArr.source == 0) {
            // this.dialogVisibleImg = true
            // this.lookFlag = false
            // res.forEach((item, index) => {
            //   this.imgList2.push(item.url)
            // })
            this.addMarkLookBox = true

            if (this.imgData[0].urlPrimary.substring(this.imgData[0].urlPrimary.length - 3) === 'pdf') {
              this.pdfFlag = true
            } else {
              this.pdfFlag = false
            }
            this.path = this.imgData[0].url
          } else {
            let formData = new FormData()
            formData.append('url', res[0].urlPrimary)
            getSBillFileUrl(formData).then(res => {
              this.$router.push({
                // 核心语句
                path: '/pdf', // 跳转的路径
                query: {
                  // 路由传参时push和query搭配使用 ，作用时传递参数
                  path: res
                }
              })
            })
          }

          // if (this.imgList2.length == 0) {
          //   this.lookFlag = true
          // }
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 点击凭证放大
    getSrcList (index) {
      return this.imgList2.slice(index).concat(this.imgList2.slice(0, index))
    },
    dianjixuanzhongXQ (val) {
      this.xuanzhongArrXQ = val
    }

  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/transferCheck')
  },
  mounted () {
    this.getRelationCustomerS()
    this.getTEmptyChangeMasterLists()
    let h = this.$refs.searchBox.offsetHeight
    let h2 = this.$refs.searchBox2.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = 0.6 * pH - h - 100 + 'px'
    this.detailsH = 0.4 * pH - h2 - 190 + 'px'
  }
}
</script>

<style lang="less" scoped>
.inpBox {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}

.ruKuZuoyeWarp {
  width: 100%;
  position: relative;
}

.box1 {
  overflow: hidden;
}

.leftbox {
  width: 250px;
  float: left;
  border-right: 1px solid black;
  height: calc(100vh - 250px);
  overflow-y: auto;
  // height:150px;
  // background-color:red;
  // .imgbox{
  //   border-bottom: 1px solid #ccc;
  // }

}

.rightbox {
  margin-left: 40px;
  width: 850px;
  float: left;

  // height:150px;
  // background-color:yellow;
  .pdfbox {
    height: calc(100vh - 250px);
  }
}

.img_box {

  // width: 100%;
  // display: flex;
  // flex-direction: row;
  // align-items: flex-start;
  // flex-wrap: wrap;
  div {
    widows: 150px;
    height: 160px;
    margin-right: 5px;
    // border: 1px dashed #ccc;
    // border-radius: 10px;
    padding: 2px;

    img {
      width: 150px;
      height: 150px;
      margin-left: 50px;
    }
  }
}

.imgDialog {
  width: 100%;
  // height:60vh;
  // overflow-x: scroll;
  // overflow-y: scroll;
  text-align: center;

  img {
    height: calc(100vh - 250px);
    // background-size: 100% 100%;
  }
}

.addMarkBox {
  .addMarkBox-title {
    width: 150px;
    font-size: 18px;
    font-weight: 700;
    margin: 0 auto;
  }

  .addMarkBox-content {
    width: 45%;
    margin: 30px auto;

    div {
      padding-bottom: 5px;
      font-weight: 700;

      .ipt {
        width: 150px;
      }
    }
  }
}
</style>
